// Unified Pricing Administration Service
//
// Purpose: Admin-managed pricing for all Guardian AI products with Stripe sync
// Products: Scan Credits, Subscriptions, Consultation, Guardian Infra

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/admin/pricing.proto (package guardianai.v1.admin, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/admin/pricing.proto.
 */
export const file_guardianai_v1_admin_pricing: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_empty]);

/**
 * @generated from message guardianai.v1.admin.ScanCreditPackage
 */
export type ScanCreditPackage = Message<"guardianai.v1.admin.ScanCreditPackage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * e.g., "credits_25", "credits_100"
   *
   * @generated from field: string package_id = 2;
   */
  packageId: string;

  /**
   * User-friendly display name
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Base credits
   *
   * @generated from field: int32 credits = 4;
   */
  credits: number;

  /**
   * Bonus credits
   *
   * @generated from field: int32 bonus_credits = 5;
   */
  bonusCredits: number;

  /**
   * Price in cents (e.g., 499 = $4.99)
   *
   * @generated from field: int64 price_cents = 6;
   */
  priceCents: bigint;

  /**
   * "USD"
   *
   * @generated from field: string currency = 7;
   */
  currency: string;

  /**
   * Display description
   *
   * @generated from field: string description = 8;
   */
  description: string;

  /**
   * Show "Most Popular" badge
   *
   * @generated from field: bool is_popular = 9;
   */
  isPopular: boolean;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive: boolean;

  /**
   * Stripe Price ID after sync
   *
   * @generated from field: string stripe_price_id = 11;
   */
  stripePriceId: string;

  /**
   * Stripe Product ID after sync
   *
   * @generated from field: string stripe_product_id = 12;
   */
  stripeProductId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.ScanCreditPackage
 */
export type ScanCreditPackageJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * e.g., "credits_25", "credits_100"
   *
   * @generated from field: string package_id = 2;
   */
  packageId?: string;

  /**
   * User-friendly display name
   *
   * @generated from field: string name = 3;
   */
  name?: string;

  /**
   * Base credits
   *
   * @generated from field: int32 credits = 4;
   */
  credits?: number;

  /**
   * Bonus credits
   *
   * @generated from field: int32 bonus_credits = 5;
   */
  bonusCredits?: number;

  /**
   * Price in cents (e.g., 499 = $4.99)
   *
   * @generated from field: int64 price_cents = 6;
   */
  priceCents?: string;

  /**
   * "USD"
   *
   * @generated from field: string currency = 7;
   */
  currency?: string;

  /**
   * Display description
   *
   * @generated from field: string description = 8;
   */
  description?: string;

  /**
   * Show "Most Popular" badge
   *
   * @generated from field: bool is_popular = 9;
   */
  isPopular?: boolean;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive?: boolean;

  /**
   * Stripe Price ID after sync
   *
   * @generated from field: string stripe_price_id = 11;
   */
  stripePriceId?: string;

  /**
   * Stripe Product ID after sync
   *
   * @generated from field: string stripe_product_id = 12;
   */
  stripeProductId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.ScanCreditPackage.
 * Use `create(ScanCreditPackageSchema)` to create a new message.
 */
export const ScanCreditPackageSchema: GenMessage<ScanCreditPackage, {jsonType: ScanCreditPackageJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 0);

/**
 * @generated from message guardianai.v1.admin.CreateScanCreditPackageRequest
 */
export type CreateScanCreditPackageRequest = Message<"guardianai.v1.admin.CreateScanCreditPackageRequest"> & {
  /**
   * Unique identifier
   *
   * @generated from field: string package_id = 1;
   */
  packageId: string;

  /**
   * User-friendly display name
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 credits = 3;
   */
  credits: number;

  /**
   * @generated from field: int32 bonus_credits = 4;
   */
  bonusCredits: number;

  /**
   * @generated from field: int64 price_cents = 5;
   */
  priceCents: bigint;

  /**
   * @generated from field: string currency = 6;
   */
  currency: string;

  /**
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * @generated from field: bool is_popular = 8;
   */
  isPopular: boolean;
};

/**
 * @generated from message guardianai.v1.admin.CreateScanCreditPackageRequest
 */
export type CreateScanCreditPackageRequestJson = {
  /**
   * Unique identifier
   *
   * @generated from field: string package_id = 1;
   */
  packageId?: string;

  /**
   * User-friendly display name
   *
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: int32 credits = 3;
   */
  credits?: number;

  /**
   * @generated from field: int32 bonus_credits = 4;
   */
  bonusCredits?: number;

  /**
   * @generated from field: int64 price_cents = 5;
   */
  priceCents?: string;

  /**
   * @generated from field: string currency = 6;
   */
  currency?: string;

  /**
   * @generated from field: string description = 7;
   */
  description?: string;

  /**
   * @generated from field: bool is_popular = 8;
   */
  isPopular?: boolean;
};

/**
 * Describes the message guardianai.v1.admin.CreateScanCreditPackageRequest.
 * Use `create(CreateScanCreditPackageRequestSchema)` to create a new message.
 */
export const CreateScanCreditPackageRequestSchema: GenMessage<CreateScanCreditPackageRequest, {jsonType: CreateScanCreditPackageRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 1);

/**
 * @generated from message guardianai.v1.admin.UpdateScanCreditPackageRequest
 */
export type UpdateScanCreditPackageRequest = Message<"guardianai.v1.admin.UpdateScanCreditPackageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * User-friendly display name
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 credits = 3;
   */
  credits: number;

  /**
   * @generated from field: int32 bonus_credits = 4;
   */
  bonusCredits: number;

  /**
   * @generated from field: int64 price_cents = 5;
   */
  priceCents: bigint;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: bool is_popular = 7;
   */
  isPopular: boolean;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;
};

/**
 * @generated from message guardianai.v1.admin.UpdateScanCreditPackageRequest
 */
export type UpdateScanCreditPackageRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * User-friendly display name
   *
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: int32 credits = 3;
   */
  credits?: number;

  /**
   * @generated from field: int32 bonus_credits = 4;
   */
  bonusCredits?: number;

  /**
   * @generated from field: int64 price_cents = 5;
   */
  priceCents?: string;

  /**
   * @generated from field: string description = 6;
   */
  description?: string;

  /**
   * @generated from field: bool is_popular = 7;
   */
  isPopular?: boolean;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive?: boolean;
};

/**
 * Describes the message guardianai.v1.admin.UpdateScanCreditPackageRequest.
 * Use `create(UpdateScanCreditPackageRequestSchema)` to create a new message.
 */
export const UpdateScanCreditPackageRequestSchema: GenMessage<UpdateScanCreditPackageRequest, {jsonType: UpdateScanCreditPackageRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 2);

/**
 * @generated from message guardianai.v1.admin.DeleteScanCreditPackageRequest
 */
export type DeleteScanCreditPackageRequest = Message<"guardianai.v1.admin.DeleteScanCreditPackageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.admin.DeleteScanCreditPackageRequest
 */
export type DeleteScanCreditPackageRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.admin.DeleteScanCreditPackageRequest.
 * Use `create(DeleteScanCreditPackageRequestSchema)` to create a new message.
 */
export const DeleteScanCreditPackageRequestSchema: GenMessage<DeleteScanCreditPackageRequest, {jsonType: DeleteScanCreditPackageRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 3);

/**
 * @generated from message guardianai.v1.admin.ListScanCreditPackagesResponse
 */
export type ListScanCreditPackagesResponse = Message<"guardianai.v1.admin.ListScanCreditPackagesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.ScanCreditPackage packages = 1;
   */
  packages: ScanCreditPackage[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.admin.ListScanCreditPackagesResponse
 */
export type ListScanCreditPackagesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.ScanCreditPackage packages = 1;
   */
  packages?: ScanCreditPackageJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.admin.ListScanCreditPackagesResponse.
 * Use `create(ListScanCreditPackagesResponseSchema)` to create a new message.
 */
export const ListScanCreditPackagesResponseSchema: GenMessage<ListScanCreditPackagesResponse, {jsonType: ListScanCreditPackagesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 4);

/**
 * @generated from message guardianai.v1.admin.SubscriptionPlan
 */
export type SubscriptionPlan = Message<"guardianai.v1.admin.SubscriptionPlan"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * "basic", "premium", "enterprise"
   *
   * @generated from field: string plan_id = 2;
   */
  planId: string;

  /**
   * Display name
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * Monthly price in cents
   *
   * @generated from field: int64 price_cents = 5;
   */
  priceCents: bigint;

  /**
   * @generated from field: string currency = 6;
   */
  currency: string;

  /**
   * "monthly", "yearly"
   *
   * @generated from field: string interval = 7;
   */
  interval: string;

  /**
   * Feature list
   *
   * @generated from field: repeated string features = 8;
   */
  features: string[];

  /**
   * @generated from field: guardianai.v1.admin.SubscriptionLimits limits = 9;
   */
  limits?: SubscriptionLimits;

  /**
   * @generated from field: bool is_popular = 10;
   */
  isPopular: boolean;

  /**
   * @generated from field: bool is_active = 11;
   */
  isActive: boolean;

  /**
   * @generated from field: string stripe_price_id = 12;
   */
  stripePriceId: string;

  /**
   * @generated from field: string stripe_product_id = 13;
   */
  stripeProductId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string stripe_url = 16;
   */
  stripeUrl: string;

  /**
   * @generated from field: string product_slug = 17;
   */
  productSlug: string;

  /**
   * @generated from field: map<string, int32> product_quotas = 18;
   */
  productQuotas: { [key: string]: number };

  /**
   * @generated from field: map<string, string> product_metadata = 19;
   */
  productMetadata: { [key: string]: string };
};

/**
 * @generated from message guardianai.v1.admin.SubscriptionPlan
 */
export type SubscriptionPlanJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * "basic", "premium", "enterprise"
   *
   * @generated from field: string plan_id = 2;
   */
  planId?: string;

  /**
   * Display name
   *
   * @generated from field: string name = 3;
   */
  name?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * Monthly price in cents
   *
   * @generated from field: int64 price_cents = 5;
   */
  priceCents?: string;

  /**
   * @generated from field: string currency = 6;
   */
  currency?: string;

  /**
   * "monthly", "yearly"
   *
   * @generated from field: string interval = 7;
   */
  interval?: string;

  /**
   * Feature list
   *
   * @generated from field: repeated string features = 8;
   */
  features?: string[];

  /**
   * @generated from field: guardianai.v1.admin.SubscriptionLimits limits = 9;
   */
  limits?: SubscriptionLimitsJson;

  /**
   * @generated from field: bool is_popular = 10;
   */
  isPopular?: boolean;

  /**
   * @generated from field: bool is_active = 11;
   */
  isActive?: boolean;

  /**
   * @generated from field: string stripe_price_id = 12;
   */
  stripePriceId?: string;

  /**
   * @generated from field: string stripe_product_id = 13;
   */
  stripeProductId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: string stripe_url = 16;
   */
  stripeUrl?: string;

  /**
   * @generated from field: string product_slug = 17;
   */
  productSlug?: string;

  /**
   * @generated from field: map<string, int32> product_quotas = 18;
   */
  productQuotas?: { [key: string]: number };

  /**
   * @generated from field: map<string, string> product_metadata = 19;
   */
  productMetadata?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.admin.SubscriptionPlan.
 * Use `create(SubscriptionPlanSchema)` to create a new message.
 */
export const SubscriptionPlanSchema: GenMessage<SubscriptionPlan, {jsonType: SubscriptionPlanJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 5);

/**
 * @generated from message guardianai.v1.admin.SubscriptionLimits
 */
export type SubscriptionLimits = Message<"guardianai.v1.admin.SubscriptionLimits"> & {
  /**
   * -1 for unlimited
   *
   * @generated from field: int32 scans_per_month = 1;
   */
  scansPerMonth: number;

  /**
   * @generated from field: int32 reports_per_month = 2;
   */
  reportsPerMonth: number;

  /**
   * @generated from field: int32 storage_gb = 3;
   */
  storageGb: number;
};

/**
 * @generated from message guardianai.v1.admin.SubscriptionLimits
 */
export type SubscriptionLimitsJson = {
  /**
   * -1 for unlimited
   *
   * @generated from field: int32 scans_per_month = 1;
   */
  scansPerMonth?: number;

  /**
   * @generated from field: int32 reports_per_month = 2;
   */
  reportsPerMonth?: number;

  /**
   * @generated from field: int32 storage_gb = 3;
   */
  storageGb?: number;
};

/**
 * Describes the message guardianai.v1.admin.SubscriptionLimits.
 * Use `create(SubscriptionLimitsSchema)` to create a new message.
 */
export const SubscriptionLimitsSchema: GenMessage<SubscriptionLimits, {jsonType: SubscriptionLimitsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 6);

/**
 * @generated from message guardianai.v1.admin.UpdateSubscriptionPlanRequest
 */
export type UpdateSubscriptionPlanRequest = Message<"guardianai.v1.admin.UpdateSubscriptionPlanRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: int64 price_cents = 4;
   */
  priceCents: bigint;

  /**
   * @generated from field: repeated string features = 5;
   */
  features: string[];

  /**
   * @generated from field: guardianai.v1.admin.SubscriptionLimits limits = 6;
   */
  limits?: SubscriptionLimits;

  /**
   * @generated from field: bool is_popular = 7;
   */
  isPopular: boolean;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * @generated from field: string stripe_url = 9;
   */
  stripeUrl: string;

  /**
   * @generated from field: string stripe_price_id = 10;
   */
  stripePriceId: string;

  /**
   * @generated from field: string product_slug = 11;
   */
  productSlug: string;

  /**
   * @generated from field: map<string, int32> product_quotas = 12;
   */
  productQuotas: { [key: string]: number };

  /**
   * @generated from field: map<string, string> product_metadata = 13;
   */
  productMetadata: { [key: string]: string };
};

/**
 * @generated from message guardianai.v1.admin.UpdateSubscriptionPlanRequest
 */
export type UpdateSubscriptionPlanRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: int64 price_cents = 4;
   */
  priceCents?: string;

  /**
   * @generated from field: repeated string features = 5;
   */
  features?: string[];

  /**
   * @generated from field: guardianai.v1.admin.SubscriptionLimits limits = 6;
   */
  limits?: SubscriptionLimitsJson;

  /**
   * @generated from field: bool is_popular = 7;
   */
  isPopular?: boolean;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive?: boolean;

  /**
   * @generated from field: string stripe_url = 9;
   */
  stripeUrl?: string;

  /**
   * @generated from field: string stripe_price_id = 10;
   */
  stripePriceId?: string;

  /**
   * @generated from field: string product_slug = 11;
   */
  productSlug?: string;

  /**
   * @generated from field: map<string, int32> product_quotas = 12;
   */
  productQuotas?: { [key: string]: number };

  /**
   * @generated from field: map<string, string> product_metadata = 13;
   */
  productMetadata?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.admin.UpdateSubscriptionPlanRequest.
 * Use `create(UpdateSubscriptionPlanRequestSchema)` to create a new message.
 */
export const UpdateSubscriptionPlanRequestSchema: GenMessage<UpdateSubscriptionPlanRequest, {jsonType: UpdateSubscriptionPlanRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 7);

/**
 * @generated from message guardianai.v1.admin.ListSubscriptionPlansRequest
 */
export type ListSubscriptionPlansRequest = Message<"guardianai.v1.admin.ListSubscriptionPlansRequest"> & {
  /**
   * Optional: Filter by product (e.g., 'distro-engine')
   *
   * @generated from field: string product_slug = 1;
   */
  productSlug: string;
};

/**
 * @generated from message guardianai.v1.admin.ListSubscriptionPlansRequest
 */
export type ListSubscriptionPlansRequestJson = {
  /**
   * Optional: Filter by product (e.g., 'distro-engine')
   *
   * @generated from field: string product_slug = 1;
   */
  productSlug?: string;
};

/**
 * Describes the message guardianai.v1.admin.ListSubscriptionPlansRequest.
 * Use `create(ListSubscriptionPlansRequestSchema)` to create a new message.
 */
export const ListSubscriptionPlansRequestSchema: GenMessage<ListSubscriptionPlansRequest, {jsonType: ListSubscriptionPlansRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 8);

/**
 * @generated from message guardianai.v1.admin.ListSubscriptionPlansResponse
 */
export type ListSubscriptionPlansResponse = Message<"guardianai.v1.admin.ListSubscriptionPlansResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.SubscriptionPlan plans = 1;
   */
  plans: SubscriptionPlan[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.admin.ListSubscriptionPlansResponse
 */
export type ListSubscriptionPlansResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.SubscriptionPlan plans = 1;
   */
  plans?: SubscriptionPlanJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.admin.ListSubscriptionPlansResponse.
 * Use `create(ListSubscriptionPlansResponseSchema)` to create a new message.
 */
export const ListSubscriptionPlansResponseSchema: GenMessage<ListSubscriptionPlansResponse, {jsonType: ListSubscriptionPlansResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 9);

/**
 * @generated from message guardianai.v1.admin.DeleteSubscriptionPlanRequest
 */
export type DeleteSubscriptionPlanRequest = Message<"guardianai.v1.admin.DeleteSubscriptionPlanRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.admin.DeleteSubscriptionPlanRequest
 */
export type DeleteSubscriptionPlanRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.admin.DeleteSubscriptionPlanRequest.
 * Use `create(DeleteSubscriptionPlanRequestSchema)` to create a new message.
 */
export const DeleteSubscriptionPlanRequestSchema: GenMessage<DeleteSubscriptionPlanRequest, {jsonType: DeleteSubscriptionPlanRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 10);

/**
 * @generated from message guardianai.v1.admin.CreateSubscriptionPlanRequest
 */
export type CreateSubscriptionPlanRequest = Message<"guardianai.v1.admin.CreateSubscriptionPlanRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: int64 price_cents = 3;
   */
  priceCents: bigint;

  /**
   * "monthly", "yearly"
   *
   * @generated from field: string interval = 4;
   */
  interval: string;

  /**
   * @generated from field: repeated string features = 5;
   */
  features: string[];

  /**
   * @generated from field: guardianai.v1.admin.SubscriptionLimits limits = 6;
   */
  limits?: SubscriptionLimits;

  /**
   * @generated from field: bool is_popular = 7;
   */
  isPopular: boolean;

  /**
   * @generated from field: string product_slug = 8;
   */
  productSlug: string;

  /**
   * Optional initial price ID
   *
   * @generated from field: string stripe_price_id = 9;
   */
  stripePriceId: string;

  /**
   * Optional custom payment link
   *
   * @generated from field: string stripe_url = 10;
   */
  stripeUrl: string;

  /**
   * @generated from field: map<string, int32> product_quotas = 11;
   */
  productQuotas: { [key: string]: number };

  /**
   * @generated from field: map<string, string> product_metadata = 12;
   */
  productMetadata: { [key: string]: string };
};

/**
 * @generated from message guardianai.v1.admin.CreateSubscriptionPlanRequest
 */
export type CreateSubscriptionPlanRequestJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: int64 price_cents = 3;
   */
  priceCents?: string;

  /**
   * "monthly", "yearly"
   *
   * @generated from field: string interval = 4;
   */
  interval?: string;

  /**
   * @generated from field: repeated string features = 5;
   */
  features?: string[];

  /**
   * @generated from field: guardianai.v1.admin.SubscriptionLimits limits = 6;
   */
  limits?: SubscriptionLimitsJson;

  /**
   * @generated from field: bool is_popular = 7;
   */
  isPopular?: boolean;

  /**
   * @generated from field: string product_slug = 8;
   */
  productSlug?: string;

  /**
   * Optional initial price ID
   *
   * @generated from field: string stripe_price_id = 9;
   */
  stripePriceId?: string;

  /**
   * Optional custom payment link
   *
   * @generated from field: string stripe_url = 10;
   */
  stripeUrl?: string;

  /**
   * @generated from field: map<string, int32> product_quotas = 11;
   */
  productQuotas?: { [key: string]: number };

  /**
   * @generated from field: map<string, string> product_metadata = 12;
   */
  productMetadata?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.admin.CreateSubscriptionPlanRequest.
 * Use `create(CreateSubscriptionPlanRequestSchema)` to create a new message.
 */
export const CreateSubscriptionPlanRequestSchema: GenMessage<CreateSubscriptionPlanRequest, {jsonType: CreateSubscriptionPlanRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 11);

/**
 * @generated from message guardianai.v1.admin.ConsultationPricing
 */
export type ConsultationPricing = Message<"guardianai.v1.admin.ConsultationPricing"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * "Architecture Consultation"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * e.g., 50000 = $500
   *
   * @generated from field: int64 price_cents = 3;
   */
  priceCents: bigint;

  /**
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * e.g., 2 hours
   *
   * @generated from field: int32 duration_hours = 5;
   */
  durationHours: number;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: string stripe_price_id = 7;
   */
  stripePriceId: string;

  /**
   * @generated from field: string stripe_product_id = 8;
   */
  stripeProductId: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.ConsultationPricing
 */
export type ConsultationPricingJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * "Architecture Consultation"
   *
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * e.g., 50000 = $500
   *
   * @generated from field: int64 price_cents = 3;
   */
  priceCents?: string;

  /**
   * @generated from field: string currency = 4;
   */
  currency?: string;

  /**
   * e.g., 2 hours
   *
   * @generated from field: int32 duration_hours = 5;
   */
  durationHours?: number;

  /**
   * @generated from field: string description = 6;
   */
  description?: string;

  /**
   * @generated from field: string stripe_price_id = 7;
   */
  stripePriceId?: string;

  /**
   * @generated from field: string stripe_product_id = 8;
   */
  stripeProductId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.ConsultationPricing.
 * Use `create(ConsultationPricingSchema)` to create a new message.
 */
export const ConsultationPricingSchema: GenMessage<ConsultationPricing, {jsonType: ConsultationPricingJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 12);

/**
 * @generated from message guardianai.v1.admin.UpdateConsultationPricingRequest
 */
export type UpdateConsultationPricingRequest = Message<"guardianai.v1.admin.UpdateConsultationPricingRequest"> & {
  /**
   * @generated from field: int64 price_cents = 1;
   */
  priceCents: bigint;

  /**
   * @generated from field: int32 duration_hours = 2;
   */
  durationHours: number;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * @generated from message guardianai.v1.admin.UpdateConsultationPricingRequest
 */
export type UpdateConsultationPricingRequestJson = {
  /**
   * @generated from field: int64 price_cents = 1;
   */
  priceCents?: string;

  /**
   * @generated from field: int32 duration_hours = 2;
   */
  durationHours?: number;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;
};

/**
 * Describes the message guardianai.v1.admin.UpdateConsultationPricingRequest.
 * Use `create(UpdateConsultationPricingRequestSchema)` to create a new message.
 */
export const UpdateConsultationPricingRequestSchema: GenMessage<UpdateConsultationPricingRequest, {jsonType: UpdateConsultationPricingRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 13);

/**
 * @generated from message guardianai.v1.admin.StripeSyncResponse
 */
export type StripeSyncResponse = Message<"guardianai.v1.admin.StripeSyncResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: int32 products_synced = 2;
   */
  productsSynced: number;

  /**
   * @generated from field: int32 prices_synced = 3;
   */
  pricesSynced: number;

  /**
   * @generated from field: repeated string errors = 4;
   */
  errors: string[];

  /**
   * @generated from field: google.protobuf.Timestamp synced_at = 5;
   */
  syncedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.StripeSyncResponse
 */
export type StripeSyncResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: int32 products_synced = 2;
   */
  productsSynced?: number;

  /**
   * @generated from field: int32 prices_synced = 3;
   */
  pricesSynced?: number;

  /**
   * @generated from field: repeated string errors = 4;
   */
  errors?: string[];

  /**
   * @generated from field: google.protobuf.Timestamp synced_at = 5;
   */
  syncedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.StripeSyncResponse.
 * Use `create(StripeSyncResponseSchema)` to create a new message.
 */
export const StripeSyncResponseSchema: GenMessage<StripeSyncResponse, {jsonType: StripeSyncResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 14);

/**
 * @generated from message guardianai.v1.admin.PricingSummary
 */
export type PricingSummary = Message<"guardianai.v1.admin.PricingSummary"> & {
  /**
   * @generated from field: int32 scan_credit_packages_count = 1;
   */
  scanCreditPackagesCount: number;

  /**
   * @generated from field: int32 subscription_plans_count = 2;
   */
  subscriptionPlansCount: number;

  /**
   * @generated from field: bool consultation_configured = 3;
   */
  consultationConfigured: boolean;

  /**
   * @generated from field: bool infra_pricing_configured = 4;
   */
  infraPricingConfigured: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp last_stripe_sync = 5;
   */
  lastStripeSync?: Timestamp;

  /**
   * Products with changes not synced
   *
   * @generated from field: int32 pending_stripe_syncs = 6;
   */
  pendingStripeSyncs: number;
};

/**
 * @generated from message guardianai.v1.admin.PricingSummary
 */
export type PricingSummaryJson = {
  /**
   * @generated from field: int32 scan_credit_packages_count = 1;
   */
  scanCreditPackagesCount?: number;

  /**
   * @generated from field: int32 subscription_plans_count = 2;
   */
  subscriptionPlansCount?: number;

  /**
   * @generated from field: bool consultation_configured = 3;
   */
  consultationConfigured?: boolean;

  /**
   * @generated from field: bool infra_pricing_configured = 4;
   */
  infraPricingConfigured?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp last_stripe_sync = 5;
   */
  lastStripeSync?: TimestampJson;

  /**
   * Products with changes not synced
   *
   * @generated from field: int32 pending_stripe_syncs = 6;
   */
  pendingStripeSyncs?: number;
};

/**
 * Describes the message guardianai.v1.admin.PricingSummary.
 * Use `create(PricingSummarySchema)` to create a new message.
 */
export const PricingSummarySchema: GenMessage<PricingSummary, {jsonType: PricingSummaryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_pricing, 15);

/**
 * @generated from service guardianai.v1.admin.PricingAdminService
 */
export const PricingAdminService: GenService<{
  /**
   * ---- Scan Credit Packages ----
   *
   * @generated from rpc guardianai.v1.admin.PricingAdminService.ListScanCreditPackages
   */
  listScanCreditPackages: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListScanCreditPackagesResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.PricingAdminService.CreateScanCreditPackage
   */
  createScanCreditPackage: {
    methodKind: "unary";
    input: typeof CreateScanCreditPackageRequestSchema;
    output: typeof ScanCreditPackageSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.PricingAdminService.UpdateScanCreditPackage
   */
  updateScanCreditPackage: {
    methodKind: "unary";
    input: typeof UpdateScanCreditPackageRequestSchema;
    output: typeof ScanCreditPackageSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.PricingAdminService.DeleteScanCreditPackage
   */
  deleteScanCreditPackage: {
    methodKind: "unary";
    input: typeof DeleteScanCreditPackageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.PricingAdminService.SyncScanCreditPackagesToStripe
   */
  syncScanCreditPackagesToStripe: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof StripeSyncResponseSchema;
  },
  /**
   * ---- Subscription Plans ----
   * ---- Subscription Plans ----
   *
   * @generated from rpc guardianai.v1.admin.PricingAdminService.ListSubscriptionPlans
   */
  listSubscriptionPlans: {
    methodKind: "unary";
    input: typeof ListSubscriptionPlansRequestSchema;
    output: typeof ListSubscriptionPlansResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.PricingAdminService.CreateSubscriptionPlan
   */
  createSubscriptionPlan: {
    methodKind: "unary";
    input: typeof CreateSubscriptionPlanRequestSchema;
    output: typeof SubscriptionPlanSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.PricingAdminService.UpdateSubscriptionPlan
   */
  updateSubscriptionPlan: {
    methodKind: "unary";
    input: typeof UpdateSubscriptionPlanRequestSchema;
    output: typeof SubscriptionPlanSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.PricingAdminService.SyncSubscriptionPlansToStripe
   */
  syncSubscriptionPlansToStripe: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof StripeSyncResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.PricingAdminService.DeleteSubscriptionPlan
   */
  deleteSubscriptionPlan: {
    methodKind: "unary";
    input: typeof DeleteSubscriptionPlanRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ---- Consultation Pricing ----
   *
   * @generated from rpc guardianai.v1.admin.PricingAdminService.GetConsultationPricing
   */
  getConsultationPricing: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ConsultationPricingSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.PricingAdminService.UpdateConsultationPricing
   */
  updateConsultationPricing: {
    methodKind: "unary";
    input: typeof UpdateConsultationPricingRequestSchema;
    output: typeof ConsultationPricingSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.PricingAdminService.SyncConsultationToStripe
   */
  syncConsultationToStripe: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof StripeSyncResponseSchema;
  },
  /**
   * ---- Dashboard Summary ----
   *
   * @generated from rpc guardianai.v1.admin.PricingAdminService.GetPricingSummary
   */
  getPricingSummary: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof PricingSummarySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_admin_pricing, 0);

